import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { orderBy } from 'lodash';
import { Briefs } from '../../models';
import { DialogService } from '../../services';

@Component({
  selector: 'prism-brief-modal',
  templateUrl: './brief-modal.component.html',
  styleUrls: ['./brief-modal.component.scss']
})
export class BriefModalComponent implements OnInit {
  briefs: Briefs;
  briefKeys;
  onHomePage: boolean;

  constructor(public dialogService: DialogService, private router: Router) {
  }

  ngOnInit() {
    this.onHomePage = this.router.isActive('home/jobs', true);
    const briefs = this.dialogService.inputData.briefs;
    if (!!briefs) {
      this.briefKeys = orderBy(Object.keys(briefs), ['briefTimestamp'], 'desc');
      this.briefs = briefs;
    }
  }
}
